<script>
  import {
    addAffSendingBillingApplication,
    changeAffSendingBillingApplicationStatus,
    getAffBillingAppPreviewData,
    updateAffSendingBillingApplication,
  } from 'api/affSendingBilling/application/affapplication';
  import { isBlank } from 'utils/string';
  import { getAffSimpleInfoByEntity } from 'api/affiliate/overall';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';

  export default {
    name: 'AffApplicationBaseForm',
    mixins: [financeInfoMixins],
    props: {
      dialogType: {
        type: String,
        default: 'new',
      },
      dialogVisible: {
        type: Boolean,
        default: false,
      },
      editData: {
        type: Object,
        default: () => {
          return {};
        },
      },
      changeStatus: {
        type: String,
        default: '',
      },
      affBillingAppStatusList: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    data() {
      return {
        formData: {
          recordDate: null,
          affBillingAppNumber: null,
          auditRemark: null,
          remark: null,
          auditStatus: null,
          affIdList: [],
          affEntity: null,
          affCompanyPlatform: null,
          sendEmailList: [''],
        },
        previewDataList: [],
        affiliateOptions: [],
        rules: {
          sendEmailList: [
            {
              validator: (rule, value, callback) => {
                if (value.length === 0 || (value.length === 1 && value[0] === '')) {
                  callback(new Error('At least one email is required.'));
                } else {
                  callback();
                }
              },
            },
          ],
          affBillingAppNumber: [],
          auditRemark: [],
          remark: [],
          auditStatus: [],
          affEntity: [],
          affCompanyPlatform: [],
        },
        fileList: {},
        affIds: [],
        formProcessing: false,
        previewWatchField: {
          recordDate: null,
          affCompanyPlatform: null,
          affEntity: null,
        },
      };
    },
    watch: {
      formData: {
        immediate: true,
        handler(val) {
          const { recordDate, affCompanyPlatform, affEntity } = val;
          // 值是否发生变化
          if (
            this.previewWatchField.affEntity === affEntity &&
            this.previewWatchField.affCompanyPlatform === affCompanyPlatform &&
            this.previewWatchField.recordDate === recordDate
          ) {
            return;
          }

          if (recordDate && affCompanyPlatform && affEntity) {
            setTimeout(() => {
              if (recordDate && affCompanyPlatform && affEntity) {
                this.handlePreview();
                this.previewWatchField = {
                  recordDate,
                  affCompanyPlatform,
                  affEntity,
                };
              }
            }, 500);
          }
        },
        deep: true,
      },
    },
    methods: {
      addEmail() {
        this.formData.sendEmailList.push('');
      },
      removeEmail(index) {
        if (this.formData.sendEmailList && this.formData.sendEmailList.length === 1) {
          if (index === 0) this.$message.error('至少保留一个邮箱地址');
        } else {
          this.formData.sendEmailList.splice(index, 1);
        }
      },
      updateEmail(index, value) {
        this.$set(this.formData.sendEmailList, index, value);
      },
      handleSubmit() {
        this.$refs.baseForm.validate(async (valid) => {
          if (valid) {
            this.formProcessing = true;
            try {
              switch (this.dialogType) {
                case 'new':
                  await addAffSendingBillingApplication({ ...this.formData }).then(() => {
                    this.$message({
                      message: 'Add Success',
                      type: 'success',
                    });
                    this.$emit('refresh-list');
                    this.handleClose();
                  });
                  break;
                case 'edit':
                  await updateAffSendingBillingApplication({ ...this.formData }).then(() => {
                    this.$message({
                      message: 'Update Success',
                      type: 'success',
                    });
                    this.$emit('refresh-list');
                    this.handleClose();
                  });
                  break;
                case 'status':
                  await changeAffSendingBillingApplicationStatus({
                    affBillingAppNumber: this.formData.affBillingAppNumber,
                    auditStatus: this.changeStatus,
                    auditRemark: this.formData.auditRemark,
                  }).then(() => {
                    this.$message({
                      message: 'Change Status Success',
                      type: 'success',
                    });
                    this.$emit('refresh-list');
                    this.handleClose();
                  });
                  break;
              }
            } finally {
              setTimeout(() => {
                this.formProcessing = false;
              }, 500);
            }
          } else {
            return false;
          }
        });
      },
      handleClose() {
        this.$emit('update:dialogVisible', false);
        this.$emit('update:changeStatus', '');
        this.$refs.baseForm.resetFields();
        this.previewDataList = [];
        this.affiliateOptions = [];
        this.previewWatchField = {
          recordDate: null,
          affCompanyPlatform: null,
          affEntity: null,
        };
      },
      handlePreview() {
        const { affEntity, affCompanyPlatform, recordDate, affIdList } = this.formData;
        if (!affEntity || !affCompanyPlatform || !recordDate) {
          this.$message.error('请选择公司平台、公司实体、日期');
          return;
        }
        this.formProcessing = true;
        getAffBillingAppPreviewData({ affEntity, affCompanyPlatform, recordDate, affIdList })
          .then((response) => {
            const result = response.result;
            if (result) {
              this.formData.sendEmailList = [''];
              this.previewDataList = result;
              this.previewDataList.forEach((item) => {
                if (item.sendEmailList && item.sendEmailList.length > 0) {
                  this.formData.sendEmailList = [
                    ...new Set([...this.formData.sendEmailList, ...item.sendEmailList]),
                  ];
                }
              });
            } else {
              this.previewDataList = [];
            }
          })
          .finally(() => {
            setTimeout(() => {
              this.formProcessing = false;
            }, 500);
          });
      },
      handleAffiliateOptions() {
        this.affiliateOptions = [];
        if (isBlank(this.formData.affEntity) || isBlank(this.formData.affCompanyPlatform)) {
          return;
        }

        this.formData.affIdList = [];
        this.previewDataList = [];
        getAffSimpleInfoByEntity({
          companyEntity: this.formData.affEntity,
          companyPlatform: this.formData.affCompanyPlatform,
        }).then((response) => {
          if (response.result) {
            this.affiliateOptions = response.result;
          } else {
            this.affiliateOptions = [];
          }
        });
      },
    },
  };
</script>

<template>
  <el-dialog
    :title="dialogType === 'new' ? 'Aff Application Create' : 'Aff Application Update'"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    :width="dialogType === 'new' ? '60%' : '35%'"
    @close="handleClose"
  >
    <el-form
      label-position="left"
      label-width="180px"
      ref="baseForm"
      :model="formData"
      :rules="rules"
      :disabled="formProcessing"
      class="grid-form"
    >
      <el-form-item
        label="Application Number"
        prop="affBillingAppNumber"
        v-if="dialogType === 'status'"
        required
      >
        <el-input v-model="formData.affBillingAppNumber" />
      </el-form-item>
      <el-form-item label="Date" prop="recordDate" required v-if="dialogType === 'new'">
        <el-date-picker v-model="formData.recordDate" value-format="yyyy-MM" type="month" />
      </el-form-item>

      <el-form-item
        label="Company Platform"
        prop="affCompanyPlatform"
        required
        v-if="dialogType === 'new'"
      >
        <el-select
          v-model="formData.affCompanyPlatform"
          filterable
          clearable
          @change="handleCompanyPlatformChange(formData.affCompanyPlatform)"
        >
          <el-option v-for="item in companyPlatformList" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>

      <el-form-item label="Company Entity" required v-if="dialogType === 'new'" prop="affEntity">
        <el-select
          v-model="formData.affEntity"
          ref="companyEntityOptions"
          filterable
          clearable
          @change="handleAffiliateOptions"
        >
          <el-option
            v-for="item in specificCompanyEntity"
            :key="item.id"
            :label="item.companyEntity"
            :value="item.companyEntity"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="AffiliateId" v-if="dialogType === 'new'" prop="affIdList">
        <el-select
          v-model="formData.affIdList"
          filterable
          multiple
          clearable
          :loading="formProcessing"
        >
          <el-option
            v-for="item in affiliateOptions"
            :key="item.id"
            :label="item.id + ' - ' + item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Send Emails" v-if="dialogType === 'new'" prop="sendEmailList" required>
        <div class="multi-item-column">
          <div v-for="(input, index) in formData.sendEmailList" :key="index" class="multi-item-row">
            <el-input
              :value="input"
              @input="updateEmail(index, $event)"
              placeholder="please input"
            ></el-input>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="removeEmail(index)"
              circle
            ></el-button>
            <el-button
              @click="addEmail"
              icon="el-icon-plus"
              type="primary"
              style="margin-left: 0"
              v-if="index === 0"
              circle
            />
          </div>
        </div>
      </el-form-item>

      <el-form-item label="Remark" prop="remark" v-if="dialogType !== 'status'">
        <el-input type="textarea" maxlength="255" show-word-limit v-model="formData.remark" />
      </el-form-item>

      <el-form-item
        label="Audit Remark"
        prop="auditRemark"
        v-if="dialogType === 'status' && changeStatus !== 'EMAIL_SENT'"
      >
        <el-input
          v-model="formData.auditRemark"
          type="textarea"
          show-word-limit
          maxlength="255"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="formProcessing" @click="handleSubmit">确 定</el-button>
    </span>

    <div v-if="dialogType === 'new'">
      <h3>Preview</h3>
      <div v-if="previewDataList && previewDataList.length > 0" class="line-frame">
        <el-table :data="previewDataList" :loading="formProcessing">
          <el-table-column prop="affId" label="Aff ID" width="100" />
          <el-table-column prop="affName" label="Aff Name" width="100" />
          <el-table-column prop="affConfirmedAmount" label="Aff Confirmed Amount" width="180" />
          <el-table-column prop="affRevenue" label="Aff Revenue" width="120" />
          <el-table-column prop="affDeductionAmount" label="Aff Deduction Amount" width="180" />
          <el-table-column prop="affCoverAmount" label="Aff Cover Amount" width="180" />
          <el-table-column prop="sendEmailList" label="Send Emails" width="180">
            <template #default="scope">
              <div
                v-for="(item, index) in scope.row.sendEmailList"
                :key="index"
                style="margin-top: 5px"
              >
                <el-tag>{{ item }}</el-tag>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else class="line-frame">
        <el-empty />
      </div>
    </div>
  </el-dialog>
</template>

<style scoped lang="scss"></style>
